import React from 'react';
import { WrappedCard } from '../WrappedCard';

interface OBWIPrizeCardProps {
  username?: string;
  avatarUrl?: string;
  obwiPrizeAmount: number;
  rank?: number;
}

export const OBWIPrizeCard: React.FC<OBWIPrizeCardProps> = ({ username, avatarUrl, obwiPrizeAmount, rank }) => {
  // Determine medal based on rank (1 = gold, 2 = silver, 3 = bronze, else gold for winner)
  const getMedal = () => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return '🥇'; // Default to gold for OBWI winners
  };
  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-6 relative z-10">
        {/* User avatar */}
        {avatarUrl && (
          <div className="flex justify-center mb-6">
            <img
              src={avatarUrl}
              alt="User avatar"
              className="w-40 h-40 rounded-full object-cover border-4 border-yellow-400 shadow-2xl"
              style={{ objectPosition: 'center top' }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/avatars/default.png';
              }}
            />
          </div>
        )}
        
        <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent mb-4 drop-shadow-2xl text-center">
          Old Balance Wingate Invitational
        </h2>
        
        <div className="bg-black/60 backdrop-blur-md rounded-2xl p-6 border-2 border-yellow-400/50 shadow-2xl">
          <div className="flex flex-col items-center justify-center mb-4">
            <div className="flex items-center gap-3 mb-3">
              <span className="text-6xl md:text-7xl">{getMedal()}</span>
              <p className="text-xl md:text-2xl text-yellow-200 font-bold">
                {rank === 1 ? '1st place' : rank === 2 ? '2nd place' : rank === 3 ? '3rd place' : '1st place'}
              </p>
            </div>
          </div>
          <div className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent mb-4 text-center">
            {obwiPrizeAmount.toLocaleString()} WINGO
          </div>
          <p className="text-lg md:text-xl text-yellow-300 font-semibold text-center">
            You ran the right time, not the best time.
          </p>
        </div>
      </div>
    </WrappedCard>
  );
};

